// src/stores/map/hooks/useClearWellMap.ts
//
// Logic hook replacing the Redux `clearWellMap` thunk.
// Returns a stable callback that sets `txnId.id` to CLEAR_MAP_ID
// when the current ID differs — otherwise no-ops.
import { useCallback } from "react";

import { CLEAR_MAP_ID } from "constants/app.constants";

import { useMapStore } from "../mapStore";

/**
 * Returns a function that clears the well portion of the map result.
 *
 * Replaces the Redux thunk `clearWellMap` with a pure Zustand equivalent.
 * The returned function is idempotent — calling it when the well map is
 * already cleared is a no-op (no state update, no re-render).
 */
export function useClearWellMap(): () => void {
  const setTxnId = useMapStore((s) => s.setTxnId);

  return useCallback(() => {
    const txnId = useMapStore.getState().txnId;
    if (txnId.id === CLEAR_MAP_ID) return;
    setTxnId({ ...txnId, id: CLEAR_MAP_ID });
  }, [setTxnId]);
}
